var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._g(_vm._b({class:_vm.iconClass},'v-icon',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.iconPaths),function(index){return _c('span',{key:index,class:("path" + index)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }